export const firebaseConfig = {
  apiKey: "AIzaSyCdiAXPVZGfMeCdFvWBzTh66Z7ydBEUm7A",
  authDomain: "weblue-ee1a5.firebaseapp.com",
  projectId: "weblue-ee1a5",
  storageBucket: "weblue-ee1a5.appspot.com",
  messagingSenderId: "146274695022",
  appId: "1:146274695022:web:b18650d26355d411e9737f"
};